module.exports = __webpack_public_path__ + "static/media/capa-manager-1024.dd1da539.png";